module.exports = __webpack_public_path__ + "img/7-Mobile.fcac93aa.jpg";